import React, { useState } from "react";
import { makeStyles, Tooltip } from "@material-ui/core";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import Resume from "../../settings/resume.json";

const useStyles = makeStyles((theme) => ({
  speedDial: {
    position: 'fixed',
    top: theme.spacing(4),
    right: theme.spacing(4),
    zIndex: theme.zIndex.speedDial,
  },
  actionIcon: {
    color: theme.palette.text.primary,
    transition: 'all 0.2s ease',
    '&:hover': {
      color: theme.palette.secondary.main,
      transform: 'scale(1.2)',
    },
  },
}));

export const SpeedDials = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  const socialActions = Resume.basics.profiles.map((profile) => (
    <SpeedDialAction
      key={profile.network.toLowerCase()}
      icon={
        <i className={`${profile.x_icon} ${classes.actionIcon}`} />
      }
      tooltipTitle={
        <Tooltip title={profile.username} placement="left" arrow>
          <span>{profile.network}</span>
        </Tooltip>
      }
      tooltipOpen
      onClick={() => {
        window.open(profile.url, "_blank", "noopener,noreferrer");
        handleClose();
      }}
    />
  ));

  return (
    <SpeedDial
      ariaLabel="Social media speed dial"
      className={classes.speedDial}
      icon={<SpeedDialIcon />}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
      direction="down"
      FabProps={{
        size: 'medium',
        color: 'secondary',
      }}
    >
      {socialActions}
    </SpeedDial>
  );
};